import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWoxt2oiFIETr2QVTIHdXeJ4BJHwjXlhc",
  authDomain: "cge-tradeinpricing.firebaseapp.com",
  projectId: "cge-tradeinpricing",
  storageBucket: "cge-tradeinpricing.appspot.com",
  messagingSenderId: "512507660616",
  appId: "1:512507660616:web:4c094beb9e2707f66b0b7d",
  measurementId: "G-RY2WQ5J4NV",
};

firebase.initializeApp(firebaseConfig);

const devAppend = process.env.NODE_ENV === "development" ? "-dev" : "";

export const db = firebase.firestore();
export const storage = firebase.storage();
export const productsCollection = db.collection("Products");
export const quotesCollection = db.collection("Quotes" + devAppend);
export const receiptsCollection = db.collection("Receipts" +  devAppend);
export const emailCollection = db.collection("Emails" + devAppend);
export const configCollection = db.collection("Configuration" + devAppend);
export const addTimeStamp = firebase.firestore.FieldValue.serverTimestamp;

//add to quote in firebase
export const addClubToQuote = (detail) => {
  console.log(detail);
  firebase.firestore.FieldValue.arrayUnion(Object.assign({}, detail));
};

export default firebase;

//auth
export const login = async (email, password) => {
  const user = await firebase
    .auth()
    .signInWithEmailAndPassword(email, password);
  return user;
};

export const isAuth = () => {
  const loggedIn = firebase.auth().currentUser;

  return loggedIn;
};

export const signOut = async () => {
  const loggedOut = await firebase.auth().signOut();
  console.log(loggedOut);
  return loggedOut;
};

export const auth = firebase.auth();
